export default {
  data() {
    return {
      isLoading: true,
      switch_pinyin:false,
      not_allow_change:false,
      id_type:'',
      canChangeBirthday:false,
      spell_family:false,// 有姓 无名
      spell_both:false,// 都有
      spell_none:false,// 都没有
      noEdit: {
        // gender: "", // 性别
        phone: "", // 手机号
        idNum: "", // 身份证号
        birthDay: "", // 出生日期
      },
      vitaForm: {
        name: "", // 姓名
        family_name_spell: "", // 姓氏
        given_name_spell: "", // 名字
        gender: "", // 性别
        id_card_photo_front: "", // 身份证照片正面，（一个URL）
        id_card_photo_verso: "", // 身份证照片背面，（一个URL）
        profile_picture: "", // 个人头像，（一个URL）
        email_address: "", // 邮箱地址
        nationality: "", // 国籍
        nation: "", // 民族
        former_name: "", // 曾用名
        passport: "", // 护照号
        // date_of_birth: "", // 出生日期，时间戳
        medical_history: "", // 伤病历史
        height: "", // 身高，（cm）应该为纯数字
        weight: "", // 体重，（kg）保留一位小数
        contact_address: "", // 个人通信地址
        contact_numbers: "", // 个人联系电话，可以是座机、手机
        postcode: "", // 个人邮编
        fax_personage: "", // 个人传真
        club_name: "", // 俱乐部名称
        club_address: "", // 俱乐部地址
        club_postcode: "", // 俱乐部邮编
        club_email: "", // 俱乐部邮箱（需要验证格式）
        club_fax: "", // 俱乐部传真
        club_website: "", // 俱乐部网址
        club_telephone: "", // 俱乐部电话，可以是座机、手机
        track_suit: "", // 套服尺码
        polo_T: "", // T恤尺码
        shorts: "", // 短裤尺码
        track_shoes: "", // 跑步鞋号
        // 外语
        language_row: [
          {
            language_ids: "",
            spoken: "",
            written: "",
          }
        ],
        // 教育经历
        academic_qualification: [
          {
            time: [],
            academic_start_date: "", // 开始日期
            academic_end_date: "", // 结束日期
            academic_address: "", // 地点
            academic_venue: "", // 学校
            qualification: "", // 学历
            references_man: "", // 证明人
            contact_details: "", // 联系电话
          },
        ],
        // 培训历程
        /*coaching_qualification: [
          {
            time: [],
            train_start_date: "", // 开始日期
            train_end_date: "", // 结束日期
            train_address: "", // 培训地点
            train_certificate: "", // 培训等级
            certificate_number: "", // 证书编号
            train_references: "", // 主讲师
            train_contact_details: "", // 联系电话
          }
        ],*/
        // 执教经历
        coaching_Experience: [
          {
            time: [],
            coach_start_date: "", // 开始日期
            coach_end_date: "", // 结束日期
            coach_address: "", // 执教地点
            coach_team: "", // 执教球队
            coach_position: "", // 职务
            coach_references: "", // 证明人
            coach_contact_details: "", // 联系电话
            coach_achievements:"", //主要成绩
          }
        ],
        // 运动经历
        playing_experience: [
          {
            time: [],
            play_start_date: "", // 开始日期
            play_end_date: "", // 结束日期
            play_address: "", // 地点
            play_team: "", // 所在球队
            play_team_level: "", // 球队级别
            play_references: "", // 主教练
            play_contact_details: "", // 联系电话
            play_achievements:"", //主要成绩
          }
        ],
        // 允许手动输入
        allowd:false,
        // 教练员级别
        coa_level_data:[
          {
            level:'',
            the_lecturer:'',
            train_address:'',
            aptitude_get_date:''
          }
        ],
        // 其他荣誉和经历
        teacher_honor_experience:[{
          get_date:'',
          honor_info:''
        }],

        // 讲师级别
        // tea_level:[
        //   {
        //     get_date:'', //获得日期
        //     level:'',  //讲师级别
        //     level_type:'' , //讲师级别类型
        //     level_id:'' //讲师id
        //   }
        // ]
        tea_present:{
          level:"",
          level_id:0,
          get_date:"",
          level_type:"present"
        },
        tea_previous:{
          level:"",
          level_id:0,
          get_date:"",
          level_type:"previous"
        },
        tea_special:{
          level:"",
          level_id:0,
          get_date:"",
          level_type:"special"
        }
      },
      option: {
        disabledDate: time => {
            return (
                new Date(time).getTime()  > new Date().getTime() - 86400000
            );
        }
      },
    };
  },
};
